import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    // Docs: https://github.com/dcastil/tailwind-merge/blob/v3.3.1/docs/configuration.md#theme
    theme: {
      text: ['xxs', 'xxs1', 'default', 'base'],
      color: [
        // Base colors
        'black', 'white',
        // Black variants
        'black-90', 'black-80', 'black-70', 'black-60', 'black-50', 'black-40', 'black-30', 'black-20', 'black-10',
        // Red variants
        'red-100', 'red-90', 'red-80', 'red-70', 'red-60', 'red-50', 'red-40', 'red-30', 'red-20', 'red-10',
        // Blue variants
        'blue-100', 'blue-90', 'blue-80', 'blue-70', 'blue-60', 'blue-50', 'blue-40', 'blue-30', 'blue-20', 'blue-10',
        // Cyan variants
        'cyan-100', 'cyan-90', 'cyan-80', 'cyan-70', 'cyan-60', 'cyan-50', 'cyan-40', 'cyan-30', 'cyan-20', 'cyan-10',
        // Light green variants
        'light-green-100', 'light-green-90', 'light-green-80', 'light-green-70', 'light-green-60', 'light-green-50', 'light-green-40', 'light-green-30', 'light-green-20', 'light-green-10',
        // Dark green variants
        'dark-green-100', 'dark-green-90', 'dark-green-80', 'dark-green-70', 'dark-green-60', 'dark-green-50', 'dark-green-40', 'dark-green-30', 'dark-green-20', 'dark-green-10',
        // Yellow variants
        'yellow-100', 'yellow-90', 'yellow-80', 'yellow-70', 'yellow-60', 'yellow-50', 'yellow-40', 'yellow-30', 'yellow-20', 'yellow-10',
        // Orange variants
        'orange-100', 'orange-90', 'orange-80', 'orange-70', 'orange-60', 'orange-50', 'orange-40', 'orange-30', 'orange-20', 'orange-10',
        // Purple variants
        'purple-70', 'purple-60',
        // Pink variants
        'pink-100', 'pink-10',
        // Attention colors
        'attention-yellow', 'attention-red', 'attention-blue', 'attention-green',
        // Service colors
        'disabled', 'error', 'placeholder', 'menu-item-hover',
        // Semantic colors
        'light-gray', 'dark-gray', 'active', 'border', 'border-hover'
      ],
      font: ['inter'],
      radius: ['sm'],
      animate: ['spin', 'spin-reverse', 'collapsible-up', 'collapsible-down']
    }
  }
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
